<template>
  <div class="layout-container d-flex flex-column ">
    <!-- Header -->
    <div class="header w-100 flex-0">
      <!-- Mobile Menu -->
      <div class="mobile-menu d-flex flex-row justify-content-between align-items-center">
        <div class="logo-select">
          <img class="logo pointer" :src="nationalLogoMark" @click="gotoRoute('dashboard')">
          <!-- button to switch between beta mode and original -->
          <el-button v-if="isAuthenticated && showSwitchMode" class="ml-10" type="secondary" size="mini" @click="switchMode"> {{ isBetaMode ? 'Switch to Original' : ' Try Beta' }} Mode</el-button>
        </div>
        <!-- Floating Cart -->
        <div class="d-flex align-items-center gap-10">
        <a class="pointer search-icon mr-10" v-if="isAuthenticated" @click="gotoRoute('finder')">
          <i class="el-icon-search" style="font-size: 20px; transition: all 0.2s ease;"></i>
        </a>
        <div class="menu-btn-wrapper" @click="openSlideMenu">
          <div class="hamburger-menu">
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>

        <div class="floating-cart" @click="drawer = true" v-if="isAuthenticated && isVerified">
                  <el-button type="text" size="small">
                    <el-badge :value="cartCount" class="fs-20 pointer">
                      <i class="el-icon-shopping-cart-2 fs-10 c-white"></i>
                    </el-badge>
                  </el-button>
                </div>
        </div>
      </div>
      <slide-menu
        class="slide-menu"
        right
        :burgerIcon="false"
        :isOpen='isSlideMenuOpen'
        @closeMenu="slideMenuClose">
        <a class="pointer" v-if="isAuthenticated" @click="gotoRoute('dashboard')">
          <i class="el-icon-s-home"></i>
          <span>Dashboard</span>
        </a>
        <a class="pointer" v-if="isAuthenticated" @click="gotoRoute('finder')">
          <i class="el-icon-search"></i>
          <span>Search</span>
        </a>
        <a class="pointer" v-if="isAuthenticated" @click="gotoRoute('store')">
          <i class="el-icon-shopping-cart-2"></i>
          <span>Store</span>
        </a>
        <a class="pointer" v-if="isAuthenticated && hasAppointmentModule" @click="gotoRoute('referee')">
          <i class="el-icon-medal"></i>
          <span>Referee</span>
        </a>
        <a class="pointer" v-if="isAuthenticated" @click="gotoRoute('all-forms')">
          <i class="el-icon-document"></i>
          <span>Forms</span>
        </a>
        <a class="pointer" v-if="isAuthenticated" @click="gotoRoute('registrations')">
          <i class="el-icon-notebook-2"></i>
          <span>Registrations</span>
        </a>
        <a class="pointer" v-if="!isAuthenticated" @click="routerPush('login')">
          <i class="el-icon-user"></i>
          <span>Login</span>
        </a>
        <a class="pointer" v-if="isAuthenticated" @click="routerPush('settings')">
          <i class="el-icon-setting"></i>
          <span>Settings</span>
        </a>
        <a class="pointer" v-if="isAuthenticated" @click="routerPush('documentations')">
          <i class="el-icon-question"></i>
          <span>FAQs</span>
        </a>
        <a class="pointer" v-if="isAuthenticated" @click="logout">
          <i class="el-icon-switch-button"></i>
          <span>Logout</span>
        </a>
      </slide-menu>

      <!-- Desktop Menu -->
      <div class="desktop-menu">
        <div class="logo-select">
          <img class="logo pointer" :src="nationalLogoMark" @click="gotoRoute('dashboard')">
          <!-- button to switch between beta mode and original -->
          <el-button v-if="isAuthenticated && showSwitchMode" class="ml-10" type="secondary" size="small" @click="switchMode"> {{ isBetaMode ? 'Switch to Original' : ' Try Beta' }} Mode</el-button>
        </div>
        <div class="d-flex align-items-center">
          <el-menu
            mode="horizontal"
            @select="handleSelect"
            :default-active="defaultActive"
            :router="true">
            <el-menu-item :index="hasCustomEntity? getIndex('dashboard'): '/dashboard'" v-if="isAuthenticated && isVerified">
              <i class="el-icon-s-home"></i>
              <span>Dashboard</span>
            </el-menu-item>
            <el-menu-item class="finder-class" :index="hasCustomEntity?  getIndex('finder'): '/finder'" v-if="isAuthenticated && isVerified">
              <i class="el-icon-search"></i>
              <span>Search</span>
            </el-menu-item>
            <el-menu-item :index="hasCustomEntity?  getIndex('store'): '/store'" v-if="isAuthenticated && isVerified">
              <i class="el-icon-shopping-cart-2"></i>
              <span>Store</span>
            </el-menu-item>
            <el-menu-item :index="hasCustomEntity? getIndex('all-forms'): '/all-forms'" v-if="isAuthenticated && isVerified">
              <i class="el-icon-document"></i>
              <span>Forms</span>
            </el-menu-item>
            <el-menu-item :index="hasCustomEntity? getIndex('referee'): '/referee'" v-if="isAuthenticated && isVerified && hasAppointmentModule">
              <i class="el-icon-medal"></i>
              <span>Referee</span>
            </el-menu-item>
            <el-menu-item :index="hasCustomEntity? getIndex('registrations'): '/registrations'" v-if="isAuthenticated && isVerified">
              <i class="el-icon-notebook-2"></i>
              <span>Registrations</span>
            </el-menu-item>
            <el-menu-item  v-if="!isAuthenticated" class="login-class">Login</el-menu-item>
            <el-menu-item v-if="isAuthenticated && isVerified" class="user-menu-item">
              <el-dropdown v-show="isAuthenticated && isVerified" trigger="click" class="user-dropdown" @command="handleUserCommand">
                <div class="user-container el-dropdown-link pointer d-flex align-items-center">
                  <el-avatar class="bg-secondary avatar">{{userNameAbbr}}</el-avatar>
                  <span class="username">{{userName}}</span>
                  <i class="el-icon-arrow-down el-icon--right" />
                </div>
                <template v-slot:dropdown>
                  <el-dropdown-menu class="user-menu">
                    <el-dropdown-item command="settings">Settings</el-dropdown-item>
                    <el-dropdown-item command="documentations">FAQs</el-dropdown-item>
                    <el-dropdown-item command="logout" divided>Logout</el-dropdown-item>
                  </el-dropdown-menu>
                </template>
              </el-dropdown>
            </el-menu-item>
          </el-menu>
            <!-- Floating Cart -->
            <div class="floating-cart" @click="drawer = true" v-if="isAuthenticated && isVerified">
                  <el-button type="text" size="small">
                    <el-badge :value="cartCount" class="fs-20 pointer">
                      <i class="el-icon-shopping-cart-2 fs-10 c-white"></i>
                    </el-badge>
                  </el-button>
                </div>
        </div>
      </div>
    </div>

    <!-- Content -->
    <div class="content w-100 flex-1 d-flex flex-column  " :class="{'mobile-padding':isTablet}">
      <div class="main-content">
        <slot  />
      </div>
      <!-- powered by -->
      <div class="powered"></div>
      <!-- Footer -->
      <div class="footer w-100  d-flex flex-column flex-center">
        <div>Copyright &#169; {{ copyrightYear }} <a href="https://www.assemblesports.com/" target="_blank">Assemble Sports</a></div>
        <div>All rights reserved.</div>
      </div>
      <!-- <assemble-footer class="mt-30" v-if="isDashboard"/> -->
    </div>

    <!-- Footer -->
    <el-drawer
    :visible.sync="drawer"
    direction="rtl"
    :withHeader="false"
    :show-close="false"
    class="cart-drawer"
    :size="isMobile ? '100%' : '500px'">
    <!-- slot title -->
    <div class="cart-container">
    <div class="cart-header">
      <span class="fs-15">Your Cart</span>
      <el-button type="secondary" size="mini" @click="drawer = false">
        <i class="el-icon-close"></i>
        Close
      </el-button>
    </div>
    <div class="cart-content">
    <div v-if="teamRegistrations.length > 0" class="mb-20">
      <div class="section-header">
        <span>Team Registrations</span>
        <!-- <div>
          <el-button type="danger" size="mini" @click="deleteAllRegistrations('team')">Clear</el-button>
          <el-button type="primary" size="mini" @click="checkout('team')">Checkout</el-button>
        </div> -->
      </div>
      <div class="card-list">
        <el-card v-for="registration in teamRegistrations" :key="registration.id" class="card-cart" shadow="never">
          <div class="card-content">
              <img :src="getLogo(registration)" alt="Event Logo" class="entity-logo">
              <div class="details">
                <h3 class="m-0"><strong>{{ get(registration, 'name', '') }}</strong></h3>
                <!-- display team name -->
                <div><strong>Team:</strong> {{ registration.team.name }}</div>
                <!-- <div v-if="get(registration, 'saleableItems',[]).length > 0">
                  <div v-for="item in get(registration, 'saleableItems',[])" :key="item.id">
                    <div>{{ item.name }} - {{ item.price | formatPrice }}</div>
                  </div>
                </div> -->
              </div>
              <div class="price">{{ registration.product?.price | formatPrice }}</div>
            </div>
            <el-button class="remove-btn" type="text" @click="removeRegistration(registration)">
            <i class="el-icon-delete"></i>
          </el-button>
        </el-card>
      </div>
    </div>

    <div v-if="indvRegistrations.length > 0" class="mb-20">
        <div class="section-header">
          <span>Individual Registrations</span>
          <!-- button to delete all registrations -->
          <!-- <div>
            <el-button type="danger" size="mini" @click="deleteAllRegistrations('indv')">Clear</el-button>
            <el-button type="primary" size="mini" @click="checkout('indv')">Checkout</el-button>
          </div> -->
        </div>
        <div class="card-list">
          <el-card v-for="registration in indvRegistrations" :key="registration.id" class="card-cart" shadow="never">
            <div class="card-content">
              <img :src="getLogo(registration)" alt="Event Logo" class="entity-logo">
              <div class="details">
                <h3 class="m-0"><strong>{{ get(registration, 'entityName', '') }}</strong></h3>
                <div><strong>Member:</strong> {{ get(registration, 'profile.firstName', '') }} {{ get(registration, 'profile.lastName', '') }}</div>
                <!-- <div v-if="get(registration, 'saleableItems',[]).length > 0">
                  <div v-for="item in get(registration, 'saleableItems',[])" :key="item.id">
                    <div>{{ item.name }} - {{ item.price | formatPrice }}</div>
                  </div>
                </div> -->
              </div>
              <div class="price">{{ registration.product?.price | formatPrice }}</div>
            </div>
            <el-button class="remove-btn" type="text" @click="removeRegistration(registration)">
            <i class="el-icon-delete"></i>
          </el-button>
          </el-card>
        </div>
      </div>

    <div v-if="indvToTeamRegistrations.length > 0" class="mb-20">
      <div class="section-header">
        <span>Individual to Team Registrations</span>
        <!-- <div>
          <el-button type="danger" size="mini" @click="deleteAllRegistrations('indv-to-team')">Clear</el-button>
          <el-button type="primary" size="mini" @click="checkout('indv-to-team')">Checkout</el-button>
        </div> -->
      </div>
      <div class="card-list">
        <el-card v-for="registration in indvToTeamRegistrations" :key="registration.id" class="card-cart" shadow="never">
          <div class="card-content">
              <img :src="getLogo(registration)" alt="Event Logo" class="entity-logo">
              <div class="details">
                <h3 class="m-0"><strong>{{ get(registration, 'entityName', '') }}</strong></h3>
                <div><strong>Member:</strong> {{ get(registration, 'profile.firstName', '') }} {{ get(registration, 'profile.lastName', '') }}</div>
                <!-- display team name -->
                <div><strong>Team:</strong> {{get(registration, 'team.name', '') }}</div>
                <!-- <div v-if="get(registration, 'saleableItems',[]).length > 0">
                  <div v-for="item in get(registration, 'saleableItems',[])" :key="item.id">
                    <div>{{ item.name }} - {{ item.price | formatPrice }}</div>
                  </div>
                </div> -->
              </div>
              <div class="price">{{ registration.product?.price | formatPrice }}</div>
            </div>
            <el-button class="remove-btn" type="text" @click="removeRegistration(registration)">
            <i class="el-icon-delete"></i>
          </el-button>
        </el-card>
      </div>
    </div>

    <div v-if="bulkRegistrations.length > 0" class="mb-20">
      <div class="section-header">
        <span>Bulk Registrations</span>
        <!-- <div>
          <el-button type="danger" size="mini" @click="deleteAllRegistrations('bulk')">Clear</el-button>
          <el-button type="primary" size="mini" @click="checkout('bulk')">Checkout</el-button>
        </div> -->
      </div>
      <div class="card-list">
        <el-card v-for="registration in bulkRegistrations" :key="registration.id" class="card-cart" shadow="never">
          <div class="card-content">
              <img :src="getLogo(registration)" alt="Event Logo" class="entity-logo">
              <div class="details">
                <h3 class="m-0"><strong>{{ get(registration, 'entityName', '') }}</strong></h3>
                <div>
                  {{ get(registration, 'memberIds', []).length }} {{ get(registration, 'memberIds', []).length > 1 ? 'Members' : 'Member' }}
                </div>
                <!-- <div v-if="get(registration, 'saleableItems',[]).length > 0">
                  <div v-for="item in get(registration, 'saleableItems',[])" :key="item.id">
                    <div>{{ item.name }} - {{ item.price | formatPrice }}</div>
                  </div>
                </div> -->
              </div>
              <div class="price">{{ (registration.product?.price * registration.memberIds.length) | formatPrice }}</div>
            </div>
            <el-button class="remove-btn" type="text" @click="removeRegistration(registration)">
            <i class="el-icon-delete"></i>
          </el-button>
        </el-card>
      </div>
    </div>
    <div v-if="familyMemberships.length > 0" class="mb-20">
  <div class="section-header">
    <span>Family Memberships</span>
      </div>
      <div class="family-memberships">
        <div v-for="membership in familyMemberships" :key="membership.id" class="family-membership">
          <div class="family-header">
        <img :src="getLogo(membership)" alt="Entity Logo" class="entity-logo">
        <div class="family-info">
          <h3>{{ get(membership, 'entityName', '') }}</h3>
          <p><strong>Family:</strong> {{ get(membership, 'familyName', '') }}</p>
        </div>
        <div class="price">{{ membership.product?.price | formatPrice }}</div>
      </div>
      <div class="members">
        <div v-for="(member, index) in membership.familyRegistrations" :key="index" class="member">
          <div class="member-details">
            <span class="member-name">{{ get(member, 'profile.firstName', '') }} {{ get(member, 'profile.lastName', '') }}</span>
            <!-- <span class="member-age">{{ calculateAge(get(member, 'profile.dob', '')) }} years old</span> -->
            <el-tag size="mini" type="info">Joining as: {{ get(member, 'memberType', '') }}</el-tag>
          </div>
        </div>
      </div>
      <el-button class="remove-btn" type="text" @click="removeRegistration(membership)">
            <i class="el-icon-delete"></i>
          </el-button>
    </div>
      </div>
    </div>
    <div v-if="directSaleableItems.length > 0" class="mb-20">
            <div class="section-header">
              <span>Items</span>
            </div>
            <div class="card-list">
              <el-card v-for="item in directSaleableItems" :key="item._id" class="card-cart" shadow="never">
                <div class="card-content">
                  <img :src="getItemImage(item)" alt="Item Image" class="entity-logo">
                  <div class="details">
                    <h3 class="m-0"><strong>{{ item.name }}</strong></h3>
                    <div>{{ item.description }}</div>
                    <div>Quantity: {{ item.qty }}</div>
                    <!-- <div v-if="item.gender">Gender: {{ item.gender }}</div> -->
                    <div v-if="item.requiresSize">Size Required</div>
                  </div>
                  <div class="price">{{ item?.price | formatPrice }}</div>
                </div>
                <el-button class="remove-btn" type="text" @click="removeItem(item)">
                  <i class="el-icon-delete"></i>
                </el-button>
              </el-card>
            </div>
          </div>
    </div>
    <div class="section-footer">
      <div class="total d-flex justify-content-between">
        <strong>Total:</strong>
        <span>{{ totalPrice | formatPrice }}</span>
      </div>
      <el-divider />
      <div class="button-group d-flex justify-content-center mt-10">
        <el-button type="danger" size="medium" @click="deleteAllRegistrations('all')">Clear All</el-button>
        <el-button type="primary" size="medium" @click="checkout('all')">Checkout</el-button>
      </div>
    </div>
  </div>
  </el-drawer>
  </div>
</template>

<script>
import _, { capitalize } from 'lodash';
// import AssembleFooter from '../components/AssembleFooter.vue';
import { mapActions } from 'vuex';
import SlideMenu from '../components/slide-menu/SlideMenu.vue';
import { getContrastColor } from '../utils/helpers';

export default {
  name: 'AppLayout',
  props: [],
  components: {
    SlideMenu,
    // AssembleFooter,
  },
  data() {
    return {
      get: _.get,
      windowWidth: window.innerWidth,
      isSlideMenuOpen: false,
      entityLevel: undefined,
      entityName: undefined,
      entityBrandings: [
      ],
      capitalize,
      selectedBranding: {
        slug: undefined,
        entityLevel: undefined,

      },
      drawer: false,
      defaultRegoLogo: process.env.VUE_APP_LOGO,
      hasRefereeAccess: false,
    };
  },
  async mounted() {
    // handle rezie event
    window.addEventListener('resize', this.handleResize);
    this.handleResize();
    const selectionCss = document.querySelector('[name="brandings-selection"]');
    // set background color of select dropdown
    if (selectionCss) {
      selectionCss.style.backgroundColor = 'var(--highlight-color)';
      selectionCss.style.color = 'white';
      selectionCss.style.border = '1px solid var(--secondary-color)';
    }

    // Check if user has referee access
    if (this.isAuthenticated && this.isVerified) {
      await this.checkRefereeAccess();
    }

    // const resEntityBrandings = await this.$http.get('assemble/api/v1/portal/national/get/entity-brandings');
    // this.entityBrandings = resEntityBrandings.data.data;
    // assign default branding to national level entityBrandings array
    // this.entityBrandings[0].options.push({
    //   slug: 'default',
    //   name: 'Default',
    //   entityLevel: 'default',
    //   // eslint-disable-next-line global-require
    //   imgUrl: process.env.VUE_APP_LOGO_MARK && process.env.VUE_APP_LOGO_MARK !== '' ? process.env.VUE_APP_LOGO_MARK : require('@/assets/logos/mark/Assemble_Logo_Mark_RGB_Negative.png')
    // });
    // set default branding
    let textColorPrimary = '';
    let textColorSecondary = '';
    const activeEntity = this.$store.getters['national/getEntity'];
    if (activeEntity && activeEntity.level && activeEntity.name) {
      this.entityLevel = activeEntity.level;
      this.entityName = activeEntity.name;
      const meta = this.$store.getters['national/getMeta'];
      if (meta && meta.primaryColor && meta.secondaryColor) {
        textColorPrimary = getContrastColor(meta.primaryColor);
        textColorSecondary = getContrastColor(meta.secondaryColor);
        document.documentElement.style.setProperty('--highlight-color', meta.primaryColor);
        document.documentElement.style.setProperty('--secondary-color', meta.secondaryColor);
      } else {
        textColorPrimary = getContrastColor(process.env.VUE_APP_HIGHLIGHT_COLOR);
        textColorSecondary = getContrastColor(process.env.VUE_APP_SECONDARY_COLOR);
        document.documentElement.style.setProperty('--highlight-color', process.env.VUE_APP_HIGHLIGHT_COLOR);
        document.documentElement.style.setProperty('--secondary-color', process.env.VUE_APP_SECONDARY_COLOR);
      }
    } else {
      this.$store.commit('national/resetCustom', {});
      // this.selectedBranding = {
      //   slug: 'default',
      //   entityLevel: 'default',
      // };
      textColorPrimary = getContrastColor(process.env.VUE_APP_HIGHLIGHT_COLOR);
      textColorSecondary = getContrastColor(process.env.VUE_APP_SECONDARY_COLOR);
      document.documentElement.style.setProperty('--highlight-color', process.env.VUE_APP_HIGHLIGHT_COLOR);
      document.documentElement.style.setProperty('--secondary-color', process.env.VUE_APP_SECONDARY_COLOR);
    }
    document.documentElement.style.setProperty('--text-color-primary', textColorPrimary);
    document.documentElement.style.setProperty('--text-color-secondary', textColorSecondary);
  },
  methods: {
    ...mapActions({
      removeRegistrationFromStore: 'cart/removeRegistration',
      removeItemFromStore: 'cart/removeDirectSaleableItem'
    }),
    async checkRefereeAccess() {
      try {
        // Get all members with registrations
        // Backend will include hasRefereeAccess flag in the response
        const resMember = await this.$http.get('/assemble/api/v1/account/portal/members-with-registrations');
        if (resMember.data && resMember.data.data) {
          // Check if backend provided the hasRefereeAccess flag
          // The backend should check if any member has registrations with referee member type
          this.hasRefereeAccess = resMember.data.hasRefereeAccess || false;
        } else {
          this.hasRefereeAccess = false;
        }
      } catch (error) {
        console.error('Error checking referee access:', error);
        // Default to false if there's an error
        this.hasRefereeAccess = false;
      }
    },
    getItemImage(item) {
      return item.images && item.images.length > 0 ? item.images[0].url : this.defaultRegoLogo;
    },
    removeItem(item) {
      this.$confirm('Are you sure you want to remove this item?', 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning',
      }).then(() => {
        this.removeItemFromStore(item._id);
      }).catch(() => {
        this.$message({
          type: 'info',
          message: 'Delete canceled',
        });
      });
    },

    deleteAllItems() {
      this.$confirm('Are you sure you want to clear all items from your cart?', 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning',
      }).then(() => {
        this.$store.commit('cart/clearDirectSaleableItems');
        this.$store.commit('cart/deleteAllRegistrations');
      }).catch(() => {
        this.$message({
          type: 'info',
          message: 'Clear canceled',
        });
      });
    },

    removeRegistration(registration) {
      this.$confirm('Are you sure you want to remove this registration?', 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning',
      }).then(async () => {
        const payload = {
          productId: registration.product._id,
          productType: registration.productType
        };

        if (registration.productType === 'indv' || (registration.productType === 'indv-to-team' && !registration.isBulk)) {
          payload.memberId = registration.memberId;
        } else if (registration.productType === 'team') {
          payload.teamName = registration.team.name;
        } else if (registration.isBulk) {
          payload.memberIds = registration.memberIds;
        }

        const result = await this.removeRegistrationFromStore(payload);
        if (!result.success) {
          this.$message.error(result.error);
          return;
        }

        this.drawer = false;
      }).catch(() => {
        this.$message({
          type: 'info',
          message: 'Delete canceled',
        });
      });
    },
    checkout(type) {
      // if (type === 'indv') {

      // }
      // if (type === 'bulk') {
      //   const pathName = this.hasCustomEntity ? 'custom-bulk-payment' : 'bulk-payment';
      //   if (_.get(this, 'bulkRegistrations', []).length > 0) {
      //     this.drawer = false;
      //     this.$router.push({ name: pathName });
      //   }
      // }
      const pathName = this.hasCustomEntity ? 'custom-payment' : 'payment';
      console.log('checkout', type);
      if (_.get(this, 'registrations', []).length > 0 || this.directSaleableItems.length > 0) {
        this.drawer = false;
        this.$router.push({ name: pathName });
      }
    },
    getLogo(registration) {
      if (registration.entityLogo) {
        return registration.entityLogo;
      }
      return this.defaultRegoLogo;
    },
    deleteAllRegistrations(type) {
      // eslint-disable-next-line no-nested-ternary
      const text = type === 'indv' ? 'individual' : type === 'indv-to-team' ? 'individual to team' : type;
      this.$confirm(`Are you sure you want to delete ${text} registrations?`, 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning',
      }).then(() => {
        if (type === 'indv') {
          this.$store.commit('cart/deleteAllIndvRegistrations');
        }
        if (type === 'team') {
          this.$store.commit('cart/deleteAllTeamRegistrations');
        }
        if (type === 'indv-to-team') {
          this.$store.commit('cart/deleteAllIndvToTeamRegistrations');
        }
        if (type === 'bulk') {
          this.$store.commit('cart/deleteAllBulkRegistrations');
        }
        if (type === 'all') {
          this.$store.commit('cart/deleteAllRegistrations');
        }
        this.drawer = false;
      }).catch(() => {
        this.$message({
          type: 'info',
          message: 'Delete canceled',
        });
      });
    },
    onCartClick() {
      const pathName = this.hasCustomEntity ? 'custom-payment' : 'payment';
      if (this.cartCount > 0) this.$router.push({ name: pathName });
    },
    // async handleChangeBranding() {
    //   if (this.selectedBranding.slug === this.entityName && this.selectedBranding.entityLevel === this.entityLevel) {
    //     return;
    //   }
    //   if (this.selectedBranding.slug === 'default') {
    //     this.$store.commit('national/resetCustom', {});
    //     const currentPath = this.$route.path.split('/').pop();
    //     this.$router.push(`/${currentPath}`);
    //     return;
    //   }
    //   await this.$store.dispatch('national/getSlugBranding', {
    //     entityName: this.selectedBranding.slug,
    //     entityLevel: this.selectedBranding.entityLevel,
    //   });
    //   this.entityLevel = this.selectedBranding.entityLevel;
    //   this.entityName = this.selectedBranding.slug;
    //   // get the last slug from the url
    //   const currentPath = this.$route.path.split('/').pop();
    //   // reload page to get new branding
    //   this.$router.push(`/c/${this.selectedBranding.entityLevel}/${this.selectedBranding.slug}/${currentPath}`);
    //   // reload page to get updated data
    // },
    goDashboard() {
      const pathName = this.hasCustomEntity ? 'custom-dashboard' : 'dashboard';
      this.$router.push({ name: pathName });
    },
    switchMode() {
      this.$message.success(`You are now using ${this.isBetaMode ? 'original' : 'beta'} mode`);
      if (this.isBetaMode) {
        this.$store.commit('national/setMode', { mode: 'original' });
      } else {
        this.$store.commit('national/setMode', { mode: 'beta' });
      }
      // this.$store.commit('national/switchMode');
      // this.$router.go(0);
    },
    handleResize() {
      this.windowWidth = window.innerWidth;
    },
    getIndex(route) {
      if (this.hasCustomEntity) {
        const entity = this.$store.getters['national/getEntity'];
        return `/c/${entity.level}/${entity.name}/${route}`;
      }
      return `/${route}`;
    },
    gotoRoute(route) {
      if (this.hasCustomEntity) {
        this.$router.push(`/c/${this.entityLevel}/${this.entityName}/${route}`);
      } else {
        this.$router.push(`/${route}`);
      }
      this.isSlideMenuOpen = false;
    },
    openSlideMenu(e) {
      e.preventDefault();
      e.stopPropagation();
      this.isSlideMenuOpen = true;
    },
    slideMenuClose() {
      this.isSlideMenuOpen = false;
    },
    handleSelect(val) {
      console.log('val', val);
    },
    routerPush(routerPath) {
      // console.log('routerPath', routerPath);
      this.$router.push(routerPath).catch(() => {});
      this.isSlideMenuOpen = false;
    },
    logout() {
      this.$store.commit('loading', true, 'Logging out...');
      // this.$store.commit('loadingText', 'Logging out...');
      this.$http.post('/assemble/api/v1/account/portal/logout').then(() => {
        this.$store.commit('user/logout');
        this.$store.commit('national/clearPaymentPref');
        this.$store.commit('cart/clear'); // Clear cart
        const activeEntity = this.$store.getters['national/getEntity'];
        if (activeEntity && activeEntity.level && activeEntity.name) {
          this.$router.replace(`/c/${activeEntity.level}/${activeEntity.name}/login`).catch(() => {});
        } else {
          this.$router.replace('/login').catch(() => {});
        }
        // this.$router.replace('/login').catch(() => {});
        this.isSlideMenuOpen = false;
        this.$store.commit('loading', false);
      }).catch((e) => {
        this.$message.error(e.response.data.message);
        this.$store.commit('loading', false);
      });
    },
    handleUserCommand(command) {
      const settingsPath = this.hasCustomEntity ? 'custom-settings' : 'settings';
      const documentationsPath = this.hasCustomEntity ? 'custom-documentations' : 'documentations';
      switch (command) {
        case 'settings':
          this.$router.push({ name: settingsPath });
          break;
        case 'documentations':
          this.$router.push({ name: documentationsPath });
          break;
        case 'logout':
          this.$store.commit('loading', true, 'Logging out...');
          // this.$store.commit('loadingText', 'Logging out...');
          this.$http.post('/assemble/api/v1/account/portal/logout').then(() => {
            this.$store.commit('user/logout');
            this.$store.commit('cart/clear'); // Clear cart
            const activeEntity = this.$store.getters['national/getEntity'];

            if (activeEntity && activeEntity.level && activeEntity.name) {
              this.$router.replace(`/c/${activeEntity.level}/${activeEntity.name}/login`).catch(() => {});
            } else {
              this.$store.commit('national/resetCustom', {});
              this.$router.replace('/login').catch(() => {});
            }
            // this.$store.commit('national/resetCustom', {});
            // this.$router.replace('/login').catch(() => {});
            this.$store.commit('loading', false);
          }).catch((e) => {
            this.$message.error(e.response.data.message);
            this.$store.commit('loading', false);
          });
          break;
        default:
          break;
      }
    },
  },
  computed: {
    copyrightYear() {
      return new Date().getFullYear();
    },
    nationalId() {
      return +process.env.VUE_APP_NATIONAL_ID;
    },
    showSwitchMode() {
      return false;
    },
    totalPrice() {
      return this.teamRegistrations.reduce((sum, reg) => sum + reg.product?.price, 0)
             + this.indvRegistrations.reduce((sum, reg) => sum + reg.product?.price, 0)
             + this.indvToTeamRegistrations.reduce((sum, reg) => sum + reg.product?.price, 0)
             + this.bulkRegistrations.reduce((sum, reg) => sum + (reg.product?.price * reg.memberIds.length), 0)
             + this.familyMemberships.reduce((sum, reg) => sum + reg.product?.price, 0)
             + this.directSaleableItems.reduce((sum, item) => sum + (item?.price * item?.qty), 0);
    },
    cartCount() {
      return this.$store.getters['cart/counts'];
    },
    isDashboard() {
      return this.$route.path.includes('/dashboard');
    },
    isBetaMode() {
      return this.$store.getters['national/getIsBetaMode'];
    },
    isTablet() {
      return this.windowWidth <= 992;
    },
    isMobile() {
      return this.windowWidth <= 768;
    },
    hasCustomEntity() {
      const customEntity = this.$store.getters['national/getEntity'];
      if (customEntity && customEntity.level && customEntity.name) {
        return true;
      }
      return false;
    },
    nationalLogoMark() {
      const customLogo = this.$store.getters['national/getLogo'];
      if (customLogo) {
        return `${customLogo}?v=${this.moment().valueOf()}`;
      }
      // eslint-disable-next-line global-require
      return process.env.VUE_APP_LOGO_MARK && process.env.VUE_APP_LOGO_MARK !== '' ? process.env.VUE_APP_LOGO_MARK : require('@/assets/logos/mark/Assemble_Logo_Mark_RGB_Negative.png');
    },
    isAuthenticated() {
      return this.$store.getters['user/isAuthenticated'];
    },

    isVerified() {
      return this.$store.getters['user/isVerified'];
    },
    userName() {
      return this.$store.getters['user/userName'];
    },
    userNameAbbr() {
      return this.$store.getters['user/userNameAbbr'];
    },
    hasAppointmentModule() {
      return this.$store.getters['national/hasAppointmentModule'];
    },

    defaultActive() {
      return this.$route.path;
    },
    registrations() {
      return this.$store.getters['cart/registrations'];
    },
    teamRegistrations() {
      const regos = this.$store.getters['cart/registrations'];
      return regos.filter((r) => r.productType === 'team' && !r.isBulk);
    },
    indvRegistrations() {
      const regos = this.$store.getters['cart/registrations'];
      console.log('regos', regos);
      return regos.filter((r) => r.productType === 'indv' && !r.isBulk);
    },
    indvToTeamRegistrations() {
      const regos = this.$store.getters['cart/registrations'];
      return regos.filter((r) => r.productType === 'indv-to-team' && !r.isBulk);
    },
    bulkRegistrations() {
      const regos = this.$store.getters['cart/registrations'];
      return regos.filter((r) => r.isBulk);
    },
    familyMemberships() {
      const regos = this.$store.getters['cart/registrations'];
      console.log('family regos', regos.filter((r) => r.productType === 'family'));
      return regos.filter((r) => r.productType === 'family');
    },
    directSaleableItems() {
      return this.$store.getters['cart/directSaleableItems'];
    },
  },
  filters: {
    cap(value) {
      return value.charAt(0).toUpperCase() + value.slice(1);
    },
    formatPrice(value) {
      // convert for cent to dollar
      return `$${value / 100}`;
    },
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
};
</script>

<style lang="scss" scoped>

.card-cart{
  background-color: #f5f7fa;
}

:deep(.el-drawer__body) {
  padding: 1rem;
  position: relative;
  height: 100%;
  overflow-y: auto;
}
// ::v-deep .el-input--suffix .el-input__inner{
//   background: var(--highlight-color);
//   color:white;

// }

// ::v-deep .el-menu--horizontal>.el-menu-item.is-active{
//   background-color: var(--secondary-color) !important;
//   color: var(--text-color-secondary) !important;
//   // border-bottom: 2px solid var(--highlight-color) !important;
// }

.search-icon{
  font-size: 1.5rem;
  font-weight: 600;
}

::v-deep .el-dropdown{
  display: flex;

}

.layout-container {
  padding: 0;
  height: 100vh;
}

.header {
  .mobile-menu {
    display: none !important;
    background-color: var(--highlight-color);
    color: var(--text-color-primary);
    height: 65px;
    padding: 0 16px;
    position: fixed;
    top: 0;
    z-index: 100;
    width: 100%;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    backdrop-filter: blur(10px);

    .logo-select{
      display: flex;
      align-items: center;
      gap:1em;

      .logo {
        height: 40px;
        width: auto;
        object-fit: contain;
        transition: transform 0.3s ease;
        cursor: pointer;

        &:hover {
          transform: scale(1.05);
        }
      }

      .el-button {
        background-color: rgba(255, 255, 255, 0.15) !important;
        border: 1px solid rgba(255, 255, 255, 0.3) !important;
        color: var(--text-color-primary) !important;
        font-weight: 500;
        font-size: 12px;
        padding: 6px 12px;
        height: 28px;
        border-radius: 6px;
        transition: all 0.3s ease;

        &:hover {
          background-color: rgba(255, 255, 255, 0.25) !important;
          border-color: rgba(255, 255, 255, 0.4) !important;
        }
      }
      // get the element with name attribute is selection
      el-select[name=selection] {
        background-color: var(--highlight-color);
        color: var(--text-color-primary);
        border: none;
        border-radius: 0;
        padding: 0.5em 1em;
        font-size: 1.2em;
        font-weight: 600;
        width: 200px;
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;
        background-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24'><path fill='white' d='M7 10l5 5 5-5z'/><path d='M0 0h24v24H0z' fill='none'/></svg>");
        background-repeat: no-repeat;
        background-position: 95% center;
        background-size: 1.5em;
      }

    }

    .search-icon {
      i {
        color: var(--text-color-primary);
      }
      &:hover i {
        opacity: 0.8;
      }
    }

    .menu-btn-wrapper {
      cursor: pointer;
      padding: 8px;
      border-radius: 8px;
      transition: all 0.2s ease;

      &:hover {
        background-color: rgba(255, 255, 255, 0.1);
      }

      .hamburger-menu {
        width: 24px;
        height: 20px;
        position: relative;

        span {
          display: block;
          position: absolute;
          width: 100%;
          height: 3px;
          background-color: var(--text-color-primary);
          border-radius: 2px;
          transition: all 0.2s ease;

          &:nth-child(1) {
            top: 0;
          }

          &:nth-child(2) {
            top: 50%;
            transform: translateY(-50%);
          }

          &:nth-child(3) {
            bottom: 0;
          }
        }
      }
    }

    .floating-cart {
      .el-icon-shopping-cart-2 {
        color: var(--text-color-primary);
        font-size: 20px;
      }

      ::v-deep .el-badge__content {
        background-color: var(--secondary-color);
        color: var(--text-color-secondary);
      }
    }
  }

  .desktop-menu {
    height: 80px;
    position: fixed;
    width: 100%;
    z-index: 1000;
    background-color: var(--highlight-color) !important;
    color: var(--text-color-primary) !important;
    display:flex;
    justify-content:space-between;
    align-items:center;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    padding: 0 20px;
    .logo-select{
      display: flex;
      align-items: center;
      gap:1.5em;

      .logo {
        height: 50px;
        width: auto;
        object-fit: contain;
        transition: transform 0.3s ease;
        cursor: pointer;

        &:hover {
          transform: scale(1.05);
        }
      }

      .el-button {
        background-color: rgba(255, 255, 255, 0.15) !important;
        border: 1px solid rgba(255, 255, 255, 0.3) !important;
        color: var(--text-color-primary) !important;
        font-weight: 500;
        padding: 8px 16px;
        height: 36px;
        border-radius: 8px;
        transition: all 0.3s ease;

        &:hover {
          background-color: rgba(255, 255, 255, 0.25) !important;
          border-color: rgba(255, 255, 255, 0.4) !important;
          transform: translateY(-1px);
        }
      }
      // get the element with name attribute is selection
      el-select[name=selection] {
        background-color: var(--highlight-color);

        color: var(--text-color-primary) !important;
        border: none;
        border-radius: 0;
        padding: 0.5em 1em;
        font-size: 1.2em;
        font-weight: 600;
        width: 200px;
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;
        background-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24'><path fill='white' d='M7 10l5 5 5-5z'/><path d='M0 0h24v24H0z' fill='none'/></svg>");
        background-repeat: no-repeat;
        background-position: 95% center;
        background-size: 1.5em;
      }

    }

    .el-menu {
      height: 100%;
      background: inherit;
      // margin-left: 4em;
      border-bottom: none;
      .login-class{
        border-bottom: none !important;
      }
    }
    .floating-cart{
      margin-right: 2em;
      cursor: pointer;

      .el-button {
        &:hover {
          transform: scale(1.05);
          background-color: transparent;
          border-color: transparent;
        }
      }

      .el-icon-shopping-cart-2 {
        color: var(--text-color-primary);
        font-size: 20px;
        transition: all 0.2s ease;

        &:hover {
          opacity: 0.8;
        }
      }

      ::v-deep .el-badge__content {
        background-color: var(--secondary-color);
        color: var(--text-color-secondary);
        border: none;
      }
    }

    .el-menu-item {
      height: 60px;
      line-height: 60px;
      margin: 10px 3px;
      padding: 0 16px;
      color: var(--text-color-primary) !important;
      font-weight: 500;
      font-size: 15px;
      transition: all 0.3s ease;

      // Hide icons in desktop menu
      i {
        display: none;
      }
      border-radius: 12px;
      position: relative;
      overflow: hidden;
      display: flex;
      align-items: center;
      gap: 8px;

      i {
        font-size: 18px;
        margin-right: 0;
      }

      &::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(255, 255, 255, 0);
        transition: background 0.3s ease;
        z-index: -1;
      }

      &:hover {
        background-color: rgba(255, 255, 255, 0.15) !important;
        transform: translateY(-2px);

        &::before {
          background: rgba(255, 255, 255, 0.05);
        }

        .user-item {
          color: var(--text-color-primary) !important;
        }
      }

      &:focus {
        background-color: rgba(255, 255, 255, 0.15) !important;
        outline: none;
      }

      .el-link {
        padding: 0 20px;
      }

      .el-link.is-underline:hover:after {
        border: 0 !important;
      }

      &.is-active {
        background-color: rgba(255, 255, 255, 0.2) !important;
        color: var(--text-color-primary) !important;
        font-weight: 600;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);

        &::after {
          content: '';
          position: absolute;
          bottom: 0;
          left: 20%;
          right: 20%;
          height: 3px;
          border-radius: 3px;
        }
      }
    }

    // Special styling for user menu item
    .user-menu-item {
      padding: 0 !important;
      overflow: visible !important;
      background-color: transparent !important;

      &::before {
        display: none !important;
      }

      &::after {
        display: none !important;
      }

      &:hover {
        background-color: transparent !important;
        transform: none !important;

        &::before {
          background: transparent !important;
        }
      }

      &:focus {
        background-color: transparent !important;
      }

      .user-dropdown {
        height: 100%;
        width: 100%;
        display: flex;
        align-items: center;
        padding: 0 16px;
      }
    }

    .el-menu-item:not(.user-menu-item):hover,
    .el-menu-item:not(.user-menu-item):focus {
      background-color: rgba(255, 255, 255, 0.1) !important;
    }

    .el-submenu {
      height: 100%;
      line-height: 80px;
      padding: 0;

      ::v-deep .el-submenu__title {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 100% !important;
      }
    }

    ::v-deep .el-submenu__title:hover {
      background-color: rgba(255, 255, 255, 0.1) !important;
    }

    .user-container {
      color: var(--text-color-primary) !important;
      padding: 10px 16px;
      border-radius: 24px;
      transition: all 0.3s ease;
      height: auto;
      display: flex;
      align-items: center;
      gap: 8px;

      &:hover {
        background-color: rgba(255, 255, 255, 0.15);
      }

      .avatar{
        background-color: var(--secondary-color) !important;
        color: var(--text-color-secondary) !important;
        font-size: 13px;
        font-weight: 600;
        flex-shrink: 0;
      }

      .username {
        font-weight: 500;
        font-size: 15px;
        margin: 0;
        line-height: 1;
      }

      .el-icon-arrow-down {
        transition: transform 0.3s ease;
        font-size: 12px;
        margin-left: 4px;
      }

      &:hover .el-icon-arrow-down {
        transform: translateY(2px);
      }
    }
  }

  @media only screen and (max-width: 1042px) {
    .mobile-menu { display: flex !important; }
    .desktop-menu { display: none !important; }
  }
}

.content {
  padding-top:80px;
  .main-content{
    // padding: 2em;
    min-height: calc(100vh - 11.5em);
  }
}
.mobile-padding {
  padding-top: 60px;
}
.no-padding-top {
  padding-top:0px;
  .main-content{
    // padding: 2em;
    min-height: calc(100vh - 11.5em) !important;
  }
}

.footer {
  // color: var(--secondary-color);
  font-size: 0.8em;
  padding: 2em;
  height: 7em;
  @media only screen and (min-width: $md) {
    background-image: url('~@/assets/logos/assemble-poweredby-logo.svg');
    background-size: 200px;
    background-repeat: no-repeat;
    background-position: left center;
  }
  @media only screen and (max-width: $sm) {
    padding: 2em;
    height: 4em;
  }
}

.menu-popup {
  .el-menu {
    .el-menu-item {
      // background-color: $primary !important;
      height: 50px !important;
      line-height: 50px !important;

      .el-link {
        width: 100%;

        ::v-deep .el-link--inner {
          width: 100%;
        }
      }

      .el-link.is-underline:hover:after {
        border: 0 !important;
      }
    }
    .el-menu-item:hover {
      // background-color: var(--secondary-color) !important;
    }
  }
}
.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 0;
  font-weight: bold;
  border-bottom: 2px solid #ebeef5;
  margin-bottom: 10px;
}

.card-list {
  display: flex;
  flex-direction: column;
  gap: 1em;
}

.card {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: -1em;
}

.card-content {
  display: grid;
  grid-template-columns: 1fr 8fr 1fr;
  align-items: center;
  width: 100%;
  padding: -0.5em;
}

.entity-logo {
  width: 50px;
  height: 50px;
  object-fit: contain;
  margin-right: 1em;
}

.details {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 0.5em;
}

.price {
  font-weight: bold;
  margin-left: 1em;
  text-align: right;
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
  align-self: flex-start;
}

.section-footer {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  background-color: #fff;
  padding: 1rem;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
}

.total {
  font-size: 1.2em;
  display: flex;
  justify-content: space-between;
}

.button-group {
  display: flex;
  justify-content: center;
  gap: 0.5rem;
  margin-top: 10px;
}
.powered {
  @media only screen and (max-width: $sm) {
    background-image: url('~@/assets/logos/assemble-poweredby-logo.svg');
    height: 5em;
    background-size: 150px;
    background-repeat: no-repeat;
    background-position: center;
  }
}
.family-memberships {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.family-membership {
  background-color: #f5f7fa;
  border-radius: 8px;
  padding: 1.5rem;
  padding-bottom: 3rem;
  margin-bottom: 10px;
  transition: all 0.3s ease;
  position: relative;

  &:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  }
  .remove-btn {
    position: absolute;
    bottom: 5px;
    right: 15px;
    padding: 5px;
    font-size: 16px;
    color: #f56c6c;
  }
}

.family-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 1rem;

  .entity-logo {
    width: 50px;
    height: 50px;
    object-fit: contain;
  }

  .family-info {
    flex-grow: 1;

    h3 {
      margin: 0;
      font-size: 1.2rem;
    }

    p {
      margin: 0.25rem 0 0;
      font-size: 0.9rem;
    }
  }

  .price {
    font-size: 1.2rem;
    font-weight: bold;
  }
}

.members {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 1rem;
}

.member {
  background-color: white;
  border-radius: 6px;
  padding: 0.75rem;
  transition: all 0.2s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  }

  .member-details {
    display: flex;
    flex-direction: column;

    .member-name {
      font-weight: 600;
      font-size: 0.95rem;
      margin-bottom: 0.25rem;
    }

    .member-age {
      font-size: 0.85rem;
      color: #606266;
      margin-bottom: 0.5rem;
    }

    .el-tag {
      align-self: flex-start;
      font-size: 0.85rem;
    }
  }
}

@media (max-width: 768px) {
  .family-header {
    flex-direction: row;
    align-items: flex-start;

    .entity-logo {
      margin-bottom: 0.5rem;
    }

    .family-info {
      margin-left: 0;
      margin-bottom: 0.5rem;
    }
  }

  .members {
    grid-template-columns: 1fr;
    .member{
      .member-details{
        display: flex;
        flex-direction: row;
        margin-left: 0;
        margin-bottom: 0.5rem;
        justify-content: space-between;
        align-items: center;
        align-self: center;
        align-content: center;
        .member-name {
      font-weight: 600;
      font-size: 0.95rem;
      margin-bottom: 0;
    }
      }

      .member-age{
        margin-left: 0.5rem;
      }
    }
  }
}
.cart-drawer {
  :deep(.el-drawer__body) {
    padding: 0;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    height: 100%;
  }
}

.cart-container {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.cart-header {
  flex-shrink: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem;
  border-bottom: 1px solid #e0e0e0;
}

.cart-content {
  flex: 1;
  overflow-y: auto;
  padding: 1rem;
  padding-bottom: 120px; // Adjust this value based on your footer height
}

.cart-footer {
  flex-shrink: 0;
  padding: 1rem;
  background-color: #fff;
  border-top: 1px solid #e0e0e0;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
}
.card-cart {
  position: relative;
  margin-bottom: 10px;

  .remove-btn {
    position: absolute;
    bottom: 5px;
    right: 15px;
    padding: 5px;
    font-size: 16px;
    color: #f56c6c;
  }
}

</style>
